import { moduleProviderFactory } from 'core/providers';
import { PickingBatchList } from 'modules/picking-batch/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.picking-batch',
				pattern: '/picking-batches',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.picking-batch.list',
						pattern: '',
						authorization: 'pickingBatchSection.full',
						component: PickingBatchList,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/picking-batch/config.js